const Space = () => '\u00A0'
export default Space
